import * as React from "react";
import { IPricing } from "src/services/interfaces/calculator/IPricing";
import { IPrecatorio } from "src/services/interfaces/IPrecatorio";
import { formatCurrency } from "src/util/Masks/formatCurrency";

interface IPricingResultPrecatorioProps { precatorio: IPrecatorio, pricing: IPricing, showAllData: boolean }

export const PricingResultPrecatorio: React.FC<IPricingResultPrecatorioProps> = ({ precatorio, pricing, showAllData }) => (
  <>
    <span className="subtitle">Precatório</span>
    <div className="region-container">

      {!showAllData &&
        <div className="row">
          <span className="left description">Valor Atualizado:</span>
          <span className="right description">{formatCurrency(pricing?.updatedPrecatorioValue)}</span>
        </div>
      }

      {showAllData &&
        <>
          <div className="row">
            <span className="left description">Documento:</span>
            <span className="right description">{precatorio?.cpfCnpj}</span>
          </div>

          <div className="row">
            <span className="left description">Número do Processo:</span>
            <span className="right description">{precatorio?.processCode}</span>
          </div>
          <div className="row">
            <span className="left description">Tribunal:</span>
            <span className="right description">{precatorio?.court?.name}</span>
          </div>
          <div className="row">
            <span className="left description">Tipo:</span>
            <span className="right description">{precatorio?.type?.name}</span>
          </div>
          <div className="row">
            <span className="left description">Natureza:</span>
            <span className="right description">{precatorio?.nature?.name}</span>
          </div>
        </>
      }
    </div>
  </>
)


// WEBPACK FOOTER //
// ./src/components/common/pricing-result/PricingResultPrecatorio.tsx